module.exports = __webpack_public_path__ + "img/MP.c3d7e3f3.png";